// extracted by mini-css-extract-plugin
export var borderRadius = "_aa-4";
export var large = "_aa-3";
export var logoContainer = "_aa-0";
export var nameLogo = "_aa-2";
export var small = "_aa-1";